// src/app/core/services/theme.service.ts
import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private darkMode = signal<boolean>(false);
  $darkMode = this.darkMode.asReadonly();

  constructor() {
    // Inicializa o tema
    this.initializeTheme();

    // Effect para aplicar mudanças quando o signal muda
    effect(() => {
      this.applyTheme(this.darkMode());
    });
  }

  private initializeTheme(): void {
    // Verifica se tem tema salvo
    const savedTheme = localStorage.getItem('bardo-theme');

    if (savedTheme === 'dark') {
      this.darkMode.set(true);
    } else if (savedTheme === 'light') {
      this.darkMode.set(false);
    } else {
      // Se não tem tema salvo, usa como padrão o tema claro (light mode)
      this.darkMode.set(false);

      /* Código original que usava a preferência do sistema:
      const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches;
      this.darkMode.set(prefersDark);
      */
    }
  }

  private applyTheme(isDarkMode: boolean): void {
    const root = document.documentElement;

    // Adiciona classe de transição
    root.classList.add('theme-transitioning');

    // Pequeno delay para suavizar a transição
    setTimeout(() => {
      if (isDarkMode) {
        // Aplica tema escuro
        root.setAttribute('data-theme', 'dark');
        localStorage.setItem('bardo-theme', 'dark');
      } else {
        // Aplica tema claro
        root.setAttribute('data-theme', 'light');
        localStorage.setItem('bardo-theme', 'light');
      }

      // Remove classe de transição após completar
      setTimeout(() => {
        root.classList.remove('theme-transitioning');
      }, 400);
    }, 50);
  }

  // Métodos públicos
  toggleDarkMode(): void {
    this.darkMode.set(!this.darkMode());
  }

  setTheme(theme: 'light' | 'dark'): void {
    this.darkMode.set(theme === 'dark');
  }

  // Getters para facilitar o uso
  get currentTheme(): 'light' | 'dark' {
    return this.darkMode() ? 'dark' : 'light';
  }

  get isDarkMode(): boolean {
    return this.darkMode();
  }
}
